<template>
  <!--  视频新闻-->
  <div class="video-news">
    <img src="https://img.qiluyidian.net/shareimg20191216.jpg" alt="" style="z-index: -10;position: absolute">
    <div class="tips clearfix" ref="tips">
      <span class="homeIcon" :style="{backgroundImage:home_url,backgroundSize:'100%'}" @click="goHome"></span>
      <i class="rightLine"></i>
      <span class="slogon">齐鲁晚报官方APP</span>
      <span class="openApp" @click="down">打开</span>
    </div>
    <div class="loading" :style="{backgroundImage:loading_url,backgroundSize:'20%'}" v-if="loading==0"></div>
    <div class="loading" :style="{backgroundImage:error_url,backgroundSize:'50%'}" v-else-if="loading==1"></div>
    <div class="loading" :style="{backgroundImage:deleted_url,backgroundSize:'50%'}" v-else-if="loading==2"></div>
    <div class="videoWraper" :class="{videoWraperF:index==0}" ref="video" v-for="(item,index) in video">
      <div class="videoAuthor clearfix">
        <img v-if="item.userImg" :src="item.userImg" alt="">
        <img v-else src="../../common/img/headImg.png" alt="">
        <span class="name">{{item.userName}}</span>
        <span class="time">{{item.publishtime}}</span>
      </div>
      <div class="video">
        <video :src="item.videourl" height="100%" width="100%"
               :poster="item.headimg" x5-playsinline preload="none"
               playsinline webkit-playsinline controls="controls" loop="loop"></video>
      </div>
      <p class="videoTitle">{{item.title}}</p>
      <div class="editor clearfix">
        <span class="tags" v-if="item.columnName">{{item.columnName}}</span>
        <span class="tags" v-else-if="item.ownername">{{item.ownername}}</span>
        <span class="tags" v-else-if="item.source">{{item.source}}</span>
        <span class="good clearfix" @click="snap(item.newsId,index)" v-if="item.praiseStatus">
          <span class="goodIcon" :style="{backgroundImage:good_url,backgroundSize:'contain'}"></span>
          <span class="num" v-if="item.praisecount!='' && item.praisecount!=0">{{item.praisecount}}</span>
        </span>
        <span class="good clearfix" v-else @click="hasSnap(item.newsId,index)">
          <span class="goodIcon" :style="{backgroundImage:good_has_url,backgroundSize:'contain'}"></span>
          <span class="num" v-if="item.praisecount!='' && item.praisecount!=0">{{item.praisecount}}</span>
        </span>
        <span class="comment clearfix" @click="goCommentPage(item.newsId)">
          <span class="commentIcon" :style="{backgroundImage:comment_url,backgroundSize:'contain'}"></span>
          <span class="num" v-if="item.commentcount!='' && item.commentcount!=0">{{item.commentcount}}</span>
        </span>
      </div>
      <!--      <div class="mask maskActive" ref="mask"></div>-->
    </div>
    <div class="hotNewsAll" v-if="allShow == 1">
      <div class="appGoWrapper" @click="down()">
        <p class="openAppGo">打开壹点APP，查看更多视频</p>
      </div>
    </div>
    <div class="toTop" v-if="topShow">
<!--      <span class="top" :style="{backgroundImage:top_url,backgroundSize:'contain'}" @click.stop="toTop"></span>-->
      <span class="index" :style="{backgroundImage:index_url,backgroundSize:'contain'}" @click.stop="goHome"></span>
    </div>
  </div>
</template>

<script>
    import '../../common/css/reset1.css'
    import {getUrlParam, scriptFun, configData} from "../../common/js/common";
    import {videoDetails, newsSnap, praiseFlag} from "../../common/api/api";
    import {login, WXauthorize, getCookie, isWeixin} from "../../common/js/authorize";
    import {getWeixinAuth} from "../../common/js/weixinshare";

    export default {
        name: 'video-news',
        components: {},
        data() {
            return {
                home_url: "url(" + require('../../common/img/home.png') + ")",
                good_url: "url(" + require('../../common/img/zanVideo.png') + ")",
                good_has_url: "url(" + require('../../common/img/collect_has.png') + ")",
                comment_url: "url(" + require('../../common/img/commentVideo.png') + ")",
                share_url: "url(" + require('../../common/img/share.png') + ")",
                loading_url: "url(" + require('../../common/img/loading.gif') + ")",
                error_url: "url(" + require('../../common/img/newsError.png') + ")",
              deleted_url: "url(" + require('../../common/img/newsDelete.png') + ")",
                top_url: "url(" + require('../../common/img/comment.png') + ")",
                index_url: "url(" + require('../../common/img/index.png') + ")",
                video: [],
                praiseStatus: true,
                options: [],
                routeId: '',
                token: '',
                isLogin: false,
                allShow: 0,
                pageNo: 1,
                pageNoNew: '',
                videoWrap: [],
                loading: 0,
                arrayH: [],
                topShow:false,
            }
        },
        watch: {},
        mounted() {
            this.$nextTick(function () {
            //     // scriptFun();
            //     let videoArr = document.getElementsByTagName('video');
                // videoArr[0].setAttribute("autoplay", "autoplay");
                if (!isWeixin()) {
                    this.$refs.tips.style.display = 'none';
                }
                login();
                if (getCookie('token') != '' && getCookie('token') != null) {
                    this.token = getCookie('token');
                    this.isLogin = true;
                } else {
                    this.isLogin = false;
                }
            })
        },
        created() {
            this.routeId = getUrlParam('id')
            this.getPraiseFlag();
            this.getVideo();
            window.addEventListener('scroll', () => {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
                let clientHeight = document.documentElement.clientHeight;//屏高
                // 滚动两屏以上时显示返回顶部按钮
                let twoClient = clientHeight * 2;
                // if (scrollTop >= twoClient) {
                //     this.topShow = true;
                // }else {
                //     this.topShow = false;
                // }
                for (let i = 0; i < this.video.length; i++) {
                    let elementHeight = this.$refs.video[i].offsetTop; //元素高度
                    let top = elementHeight - scrollTop;//元素距离顶部高度
                    let videoH = (clientHeight - top) / 2; //判断视频播放的高度
                    let videoArr = document.getElementsByTagName('video');
                    if (top <= videoH && top >= 0) {
                        videoArr[i].setAttribute("autoplay", "autoplay");
                        videoArr[i].setAttribute("muted", "muted");
                    } else {
                        if (videoArr[i].getAttribute("autoplay")) {
                            videoArr[i].removeAttribute("autoplay");
                        }
                    }
                    if (isWeixin()) {
                        let tips = document.getElementsByClassName('tips');
                        this.arrayH.unshift(scrollTop);
                        this.arrayH.length = 2;
                        if (this.arrayH[0] > this.arrayH[1]) {//上滑
                            if (scrollTop <= 0) {
                                tips[0].style.display = 'block'
                            } else {
                                tips[0].style.display = 'none'
                            }
                        } else if (this.arrayH[0] < this.arrayH[1] || scrollTop <= 0) {//下滑
                            tips[0].style.display = 'block'
                        }
                    }
                    // let seeHeight = document.documentElement.clientHeight; //可见区域高度
                    // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条距离顶部高度
                    let scrollHeight = document.documentElement.scrollHeight;//为内容可视区域的高度加上溢出（滚动）的距离。
                    if (scrollHeight <= scrollTop + clientHeight) {
                        if (this.videoWrap.length > this.video.length) {
                            this.video.push(this.videoWrap[this.video.length]);
                          this.$nextTick(()=>{
                            let videoArr = document.getElementsByTagName('video');
                            for (let i = 0; i < videoArr.length; i++) {
                              videoArr[i].addEventListener('play', function () {
                                for (let k = 0; k < videoArr.length; k++) {
                                  if(k!=i) {
                                    videoArr[k].pause()//暂停
                                  }
                                }
                              })
                            }
                          })
                        } else {
                            this.allShow = 1;
                        }
                    }
                }
            })
        },
        methods: {
            getPraiseFlag() {
                if (getCookie('token') != '' && getCookie('token') != null) {
                    this.token = getCookie('token');
                } else {
                    this.token = '';
                }
                let params = {
                    token: this.token,
                    newsid: this.routeId
                };
                praiseFlag(params).then(res => {
                    if (res && res.data.rc == 0) {
                        if (res.data.flag == '-1') {
                            this.videoSnap = true;
                        }
                    }
                })

            },
            getVideo() {
                this.video = [];
                this.videoWrap = [];
                let id = '';
                if (getUrlParam('liveId')) {
                    id = getUrlParam('liveId') + ',' + this.routeId;
                } else {
                    id = this.routeId;
                }
                let params = {
                    "newsid": id,//"20",
                    "pageNo": 1,
                    "pageSize": 20
                };
                videoDetails(params).then(res => {
                    if (res && res.data.rc == 0) {
                        this.loading = -1;
                        this.topShow = true;
                        document.title = res.data.data[0].title;
                        getWeixinAuth();
                        // console.log(document.title)
                        for (let i = 0; i < res.data.data.length; i++) {
                            this.videoWrap.push(res.data.data[i]);
                            // this.videoWrap[i].autoplay = false;
                            // if (i == 0) {
                            //   if (this.videoSnap) {
                            //     this.video[0].praiseStatus = true;
                            //   }
                            // } else {
                            this.videoWrap[i].praiseStatus = true;
                            // }
                        }
                        if (this.videoWrap.length > 4) {
                            for (let n = 0; n < 4; n++) {
                                this.video.push(this.videoWrap[n]);
                            }
                        } else {
                            for (let n = 0; n < this.videoWrap.length; n++) {
                                this.video.push(this.videoWrap[n]);
                            }
                        }
                        this.$nextTick(function () {
                            let videoArr = document.getElementsByTagName('video');
                            for (let i = 1; i < videoArr.length; i++) {
                                if (videoArr[i].getAttribute("autoplay")) {
                                    videoArr[i].removeAttribute("autoplay");
                                }
                            }
                            // videoArr[0].setAttribute("autoplay", "autoplay");
                            if (!isWeixin()) {
                                document.getElementsByClassName('videoWraper')[0].style.paddingTop = '6px';
                            }
                            for (let i = 0; i < videoArr.length; i++) {
                              videoArr[i].addEventListener('play', function () {
                                for (let k = 0; k < videoArr.length; k++) {
                                  if(k!=i) {
                                    videoArr[k].pause()//暂停
                                  }
                                }
                              })
                            }
                        })
                    }else if(res && res.data.rc == -1){
                      this.loading = 2;
                    } else {
                        this.loading = 1;
                    }
                })
            },
            goCommentPage(val) {
                if (this.isLogin) {
                    if(getUrlParam('mwb')){
                        location.href = configData.jumpUrl + '/comment.html?id=' + val + '&mwb=' + 'mobi';
                    }else {
                        location.href = configData.jumpUrl + '/comment.html?id=' + val;
                    }
                } else {
                    WXauthorize();
                }
            },
            // 新闻点赞
            snap(newsId, index) {
                if (this.isLogin) {
                    let params = {
                        "token": this.token,
                        "newsid": newsId
                    };
                    newsSnap(params).then(res => {
                        if (res.data.rc == 0) {
                            // this.praiseStatus = false;
                            if (res.data.data.praiseDec == '-1') {
                                this.$toast.center('点赞已满');
                                this.video[index].praiseStatus = false;
                            } else {
                                this.video[index].praiseStatus = false;
                                this.video[index].praisecount++;
                                // this.getVideo();
                            }
                        }
                    })
                } else {
                    WXauthorize();
                }
            },
            hasSnap(newsId, index) {
                if (this.isLogin) {
                    let params = {
                        "token": this.token,
                        "newsid": newsId
                    };
                    newsSnap(params).then(res => {
                        if (res.data.rc == 0) {
                            // this.praiseStatus = false;
                            if (res.data.data.praiseDec == '-1') {
                                this.$toast.center('点赞已满');
                                this.video[index].praiseStatus = false;
                            } else {
                                this.video[index].praiseStatus = false;
                                this.video[index].praisecount++;
                                // this.getVideo();
                            }
                        }
                    })
                } else {
                    WXauthorize();
                }
            },
            down() {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.qlwb.qiluyidian'
                } else if (isiOS) {
                    window.location.href = 'https://itunes.apple.com/cn/app/qi-lu-yi-dian-ti-yu-gong-jiao/id903816468?mt=8'
                }
            },
            goHome() {
                if(getUrlParam('mwb')){
                    location.href = configData.jumpUrl + '/mobiIndex.html';
                }else {
                    location.href = configData.jumpUrl + '/index.html';
                }
            },
            toTop() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
        },
        // computed: {
        //   player() {
        //     return this.$refs.videoPlayer[0].player
        //   }
        // }
    }
</script>

<style lang="scss" scoped>
  @import "../../common/css/base.scss";
  @import "css/video";
</style>
<style>
  .vjs-custom-skin > .video-js .vjs-big-play-button {
    border: none;
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// App.vue?07231d96